module.exports = __webpack_public_path__ + "img/thumbnail_StandardDonkey_m_leucistic.fc5a084e.png";